import ListaParcelamento from 'components/ListaParcelamento';
import React from 'react';

function ParcelaField({
  input: { value, onChange },
  meta,
  options = [],
  opcao,
  divida = {},
}: any) {
  const showError = !!(meta.touched && meta.error);

  return (
    <ListaParcelamento
      options={options}
      onChange={onChange}
      value={value}
      showError={showError}
      opcao={opcao}
      divida={divida}
    />
  );
}

export default ParcelaField;
